module.exports = __webpack_public_path__ + "images/synchronize-arrows-square.a4f0ca3921aff09810aa3f8655fb6ed7.png";